module.exports = __webpack_public_path__ + "assets/img/loginIcon1.90140919.png";